import { Button, Container, Dialog, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import ApplicationView from '../Global/ApplicationView';
import { getOfflineApplicationRes } from '../../store/Slice/Lead/LeadSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useLeadSelector from '../../store/Slice/Lead/LeadSelector';

function ProcessLeads() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { leadesItem } = location?.state || {};

  const { LoginData } = useLoginSelector();
  const { AppData } = useLeadSelector();
  const myData = structuredClone(AppData || {});

  const getApplicationByIdApi = useCallback(() => {
    const credential = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      applicationId: leadesItem[0]?.applicationId
    };
    dispatch(getOfflineApplicationRes(credential));
  }, [LoginData, leadesItem]);

  useEffect(() => {
    getApplicationByIdApi();
  }, [getApplicationByIdApi]);

  return (
    <Page title="Partner Management System || Leads">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Post Recommendation" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <ApplicationView parent="leads" offlineResponse={myData} />
        </Box>
      </Container>
    </Page>
  );
}
export default ProcessLeads;
